/* Benitez Commercial — Scroll reveal animations
   Añade la clase .bnz-in cuando el elemento entra en el viewport.
   Respeta prefers-reduced-motion. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Selectores de elementos a animar
    var selectors = [
      '[data-bnz-reveal]',
      '.bz-section-header',
      '.bz-fcat',
      '.bz-cat-card',
      '.bz-pcard',
      '.bz-split',
      '.bz-services__item',
      '.bz-trust',
      '.bz-cta',
      '.bnz-collection-hero',
      '.bnz-brandlogo'
    ];

    // Evita duplicados si un elemento coincide con varios selectores
    var seen = [];

    var nodes = [];
    selectors.forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
        if (seen.indexOf(el) === -1) { seen.push(el); nodes.push(el); }
      });
    });

    if (!nodes.length) { return; }

    // Sin animación: mostrar todo de inmediato
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('bnz-in'); });
      return;
    }

    // Marca elementos como "preparados" para recibir el estado inicial vía CSS
    nodes.forEach(function (el, i) {
      el.classList.add('bnz-reveal');
      // Pequeño escalonado para grupos (tarjetas en grid/carrusel)
      var delay = (i % 4) * 80;
      el.style.transitionDelay = delay + 'ms';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bnz-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    nodes.forEach(function (el) { io.observe(el); });
  });
})();
